import React, { useState } from "react";
import { Grid, Box, TextField, Button } from "@mui/material";
import { makeStyles } from "@material-ui/core/styles";
import RecordButton from "../../Components/Media/RecordButton";

// Custom imports
const RewardsCard = (props) => {
  //Hooks
  const styles = useStyles();

  // State
  // const [reactionView, setReactionView] = useState(false);
  // const [modalVisible, setModalVisible] = useState(false);
  const [reaction, setReaction] = useState(null);
  const [comment, setComment] = useState("");
  const [trainerFeedbackAudio, setTrainerFeedbackAudio] = useState(null);


  // Set teacher's reaction (care, like, star)
  const setMyReaction = (reactionType) => {
    if (reactionType === reaction) {
      setReaction(null);
    } else {
      setReaction(reactionType);
    }
  };

  // Load Dynamic Image
  const loadImage = (reactionName) => {
    switch (reactionName) {
      case 'fillCare':
        return require('../../assets/fill/care.png');
      case 'outlineCare':
        return require('../../assets/outline/care.png');
      case 'fillLike':
        return require('../../assets/fill/like.png');
      case 'outlineLike':
        return require('../../assets/outline/like.png');
      case 'fillStar':
        return require('../../assets/fill/star.png');
      case 'outlineStar':
        return require('../../assets/outline/star.png');
      case "default":
        return ``;
    }
  }

  return (
    <>
      <Grid container sx={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', mt: 1, px: 6 }}>
        <Grid item xs={10} sx={{ ma: 2, backgroundColor: '#DB8829', borderRadius: 10, px: 3 }}>
          <Grid container sx={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', my: 1 }}>
            <Grid item sx={{ display: 'flex' }}>
              <Box sx={{ mx: 1 }} onClick={() => { setMyReaction("care"); }}>
                <img src={loadImage((reaction == 'care') ? 'fillCare' : 'outlineCare')} className={styles.RewardImg}></img>
              </Box>
              <Box sx={{ mx: 1 }} onClick={() => { setMyReaction("like"); }}>
                <img src={loadImage((reaction == 'like') ? 'fillLike' : 'outlineLike')} className={styles.RewardImg}></img>
              </Box>
              <Box sx={{ mx: 1 }} onClick={() => { setMyReaction("star"); }}>
                <img src={loadImage((reaction == 'star') ? 'fillStar' : 'outlineStar')} className={styles.RewardImg}></img>
              </Box>
            </Grid>
            <Grid item sx={{ flexDirection: 'row', display: 'flex' }}>
              <Box sx={{}}>
                <TextField
                  size="small"
                  sx={[{ width: '30vw', border: '1px solid #FFFFFF', backgroundColor: '#FFFFFF', borderRadius: 1 }]}
                  placeholder={"Comment..."}
                  placeholderTextColor="#FFFFFF"
                  value={comment}
                  onInput={(e) => {
                    setComment(e.target.value);
                  }}
                />
              </Box>
              <Box sx={{ mx: 2, mt: 0.5 }}>
                <RecordButton
                  size="small"
                  checkOnPause={false}
                  startRecord={(flag) => {
                    console.log("******flag", flag);
                    // setLeftRecord(flag);
                  }}
                  uploadedAudioName={(audioName) => {
                    // console.log("===>",audioName);
                    setTrainerFeedbackAudio(audioName);
                  }}
                  uploadOnPause={true}
                ></RecordButton>
              </Box>
            </Grid>
          </Grid>
        </Grid>
        <Grid xs={2} sx={{ textAlign: 'end', pr: 2 }}>
          <Button
            sx={{ color: '#FFFFFF', 
              backgroundColor: '#DB8829', fontSize: '1.2rem', px: 3, 
              borderRadius: 50,
              '@media (min-width: 1636px)':{
                fontSize: '1.6rem'
              },
             
            }}
            onClick={() => props.save(reaction, comment, trainerFeedbackAudio)}
            >
              SAVE
          </Button>
        </Grid>
      </Grid>
    </>
  );
};
const useStyles = makeStyles({
    RewardImg: {
      width: '1.9rem',
      '@media (min-width: 1636px)':{
        width: '2.5rem',
      }
    }
});

export default RewardsCard;